import app from './../index';

export default class AnfrageController {

  constructor($routeParams) {
      this.anfrage = app.api.anfragen.get({
        id: $routeParams.id
      });
  }

  markAsRead() {
    this.anfrage.$gelesen(() => {
      app.$location.path('/');
    });
  }
}

AnfrageController.$inject = ['$routeParams'];



// WEBPACK FOOTER //
// ./app/anfragen/anfrageController.js